module.exports = __webpack_public_path__ + "img/MY.8143b32a.webp";